import React from 'react';
import './brand.css';
import { brandedc,brandeds, brandinogest,brandclick} from './imports';

const Brand = () => {
  return (
    <div className='gpt3__brand section__padding'>
      <div className='gpt3__brand-heading'>
        <h2>Empresas que Confiam em Nós</h2>
        <p>Soluções desenvolvidas para diversos setores empresariais</p>
      </div>
      <div className='gpt3__brand-container'>
        <div>
          <img src={brandinogest} alt='inogest' />
        </div>
        <div>
          <img src={brandedc} alt='edc' />
        </div>
        <div>
          <img src={brandeds} alt='eds' />
        </div>
        <div>
          <img src={brandclick} alt='click' />
        </div>
      </div>
    </div>
  )
}

export default Brand
